import { invoke } from "@tauri-apps/api/core";
import { atomWithRefresh } from "jotai/utils";

import { Logger } from "@moment/logging";

import { env } from "../env/env";

const logger = new Logger("command-availability");

export type CommandInfo = {
	installed: boolean;
	path?: string;
};

export type CommandAvailability = {
	amp: CommandInfo;
	claude: CommandInfo;
	codex: CommandInfo;
	copilot: CommandInfo;
	gemini: CommandInfo;
	onePassword: CommandInfo;
};

type ScriptOutput = {
	status: number | null;
	stdout: number[];
	stderr: number[];
};

const checkCommandExists = async (command: string): Promise<CommandInfo> => {
	if (!env.isDesktopApp) {
		return { installed: false };
	}

	try {
		const whichCommand = env.isWindows ? `(Get-Command ${command}).Source` : `which ${command}`;
		const scriptBytes = new TextEncoder().encode(whichCommand);
		const result = await invoke<ScriptOutput>("run_script", {
			script: Array.from(scriptBytes),
		});

		const stdout = new TextDecoder().decode(new Uint8Array(result.stdout)).trim();

		if (result.status === 0 && stdout) {
			return {
				installed: true,
				path: stdout.split("\n")[0],
			};
		}
		return { installed: false };
	} catch (error) {
		logger.debug("Command not found", { command, error });
		return { installed: false };
	}
};

export const $commandAvailability = atomWithRefresh(async (): Promise<CommandAvailability> => {
	if (!env.isDesktopApp) {
		return {
			amp: { installed: false },
			claude: { installed: false },
			codex: { installed: false },
			copilot: { installed: false },
			gemini: { installed: false },
			onePassword: { installed: false },
		};
	}

	const [amp, claude, codex, copilot, gemini, onePassword] = await Promise.all([
		checkCommandExists("amp"),
		checkCommandExists("claude"),
		checkCommandExists("codex"),
		checkCommandExists("copilot"),
		checkCommandExists("gemini"),
		// 1Password CLI.
		checkCommandExists("op"),
	]);

	logger.debug("Command availability check complete", { amp, claude, codex, copilot, gemini });

	return { amp, claude, codex, copilot, gemini, onePassword };
});
$commandAvailability.debugLabel = "commandAvailability";
